<script>
	export default{
		data(){
			return {
				users: [
					{userid:'A0F00TH' ,nombre: 'Allison',apellidos: 'Filisola'},
					{userid:'A0R00VQ' ,nombre: 'Angelica',apellidos: 'Riveros'},
					{userid:'AAI000G' ,nombre: 'Alejandra Itzel',apellidos: 'Gonzalez'},
					{userid:'CCC0016' ,nombre: 'Christopher',apellidos: 'Calderon  Escutia'},
					{userid:'CCE0004' ,nombre: 'Cesar Eduardo',apellidos: 'Perez'},
					{userid:'DALVAR6' ,nombre: 'Dannya',apellidos: 'Alvarez'},
					{userid:'DCORDO2' ,nombre: 'Daniela',apellidos: 'Cordoba'},
					{userid:'DDI0002' ,nombre: 'Diana Iltse',apellidos: 'De La Cruz'},
					{userid:'E0R009Q' ,nombre: 'Erik Daniel',apellidos: 'Rodriguez'},
					{userid:'E2MIRAM' ,nombre: 'Elsy',apellidos: 'Miranda'}
				]
			}
		},
		mounted(){
			
		},
		methods:{
			selectComprador(comprador){
				this.$emit('setComprador',comprador);
				window.$('#comprador-modal').modal('hide');
			}
		}
	}

</script>
<template>
	<div id="comprador-modal" class="modal fade modal-second" role="dialog">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="header-modal">
					<label>Búsqueda: Identificación de usuario de aprobador</label>
					<div class="modal-header-buttons">
						<button type="button">
							<i class="far fa-window-maximize"></i>	
						</button>
						<button type="button" data-dismiss="modal" >
							<i class="fas fa-times"></i>	
						</button>
					</div>
				</div>
				<div class="body-modal pb-30">
					<table class="table-first-gray table-row-hover">
						<tr>
							<td></td>
							<td>User ID</td>
							<td>Nombre pila</td>
							<td>Apellido</td>
						</tr>
						<tr v-for="(user,index) in users" :key="index" @click="selectComprador(user)">
							<td></td>
							<td>{{user.userid}}</td>
							<td>{{user.nombre}}</td>
							<td>{{user.apellidos}}</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>